import React, { useEffect, useState } from "react";
import axios from "axios";
import { Row, Col, Button } from "react-bootstrap";
import {
  useNavigate,
  useOutletContext,
  useSearchParams,
} from "react-router-dom";
import Slider from "react-slick";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import produce from "immer";

import {
  bodyRequest,
  headers,
  quoteRequest,
  distributorQuick,
} from "../../helpers/utils";
import DefaultImg from "../../assets/images/no_image.png";
import { endpoints } from "../../helpers/endpoints";

import "../../../node_modules/slick-carousel/slick/slick.css";
import "../../../node_modules/slick-carousel/slick/slick-theme.css";
import "./style.scss";
import Map from "../../components/Maps";
import ProductItems from "./components/ProductItems";
import BasicInfo from "./components/BasicInfo";
import SkeletonDetail from "./components/SkeletonDetail";
import SkeletonItems from "./components/SkeletonItems";
import { isEmpty } from "lodash";
import { formatMoney } from "../../helpers/formatters";

const ProductDetail = () => {
  /* eslint-disable */
  const [
    language,
    wishlists,
    setWishlists,
    removeWishlist,
    categorySelected,
    setCategorySelected,
    wishlistInjection,
    addWishlist,
  ] = useOutletContext();
  /* eslint-disable-end */

  const [service, setService] = useState();
  const [bookingQuotes, setBookingQuotes] = useState([]);
  const [detailShow, setDetailShow] = useState(false);
  const [productItemShow, setProductItemShow] = useState("none");
  const [skeletonItemShow, setSkeletonItemShow] = useState("none");
  const [quotesInfo, setQuotesInfo] = useState({});
  const [errorItems, setErrorItems] = useState(false);
  const [productId, setProductId] = useState();
  const [totalPrice, setTotalPrice] = useState([]);
  const [searchParams] = useSearchParams();
  let id = searchParams.get("id");
  const { t } = useTranslation();
  const navigate = useNavigate();

  const today = new Date();
  const date = new Date(today);
  date.setDate(date.getDate() + 1);

  const detailRequest = bodyRequest;

  useEffect(() => {
    const wishlistsStorage = JSON.parse(localStorage.getItem("wishlists"));
    setWishlists(wishlistsStorage);
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    id = id.includes("shopping-") ? id.replace("shopping-", "") : id;
    delete detailRequest.request.Paging.Token;

    detailRequest.request.Availability = {
      MergeMethod: 1,
      Window: {
        Size: 42,
        StartDate: new Date(),
      },
    };

    detailRequest.request.Campaign = {
      AdCampaignCode: "",
      DealCampaignCode: "",
    };

    detailRequest.request.Filter = {
      TagCritera: {},
      Type: "Service",
      Bookability: {},
      Ids: "",
    };

    detailRequest.request.Filter.Ids = [id];

    setDetailShow(false);
    setProductItemShow("none");

    detailRequest.request.Output.Children = {
      Output: {
        CommonContent: {
          All: true,
        },
        Features: true,
        Rating: true,
        Reviews: {
          IncludeFullDescription: true,
          IncludeShortReview: true,
          MaxReturnCount: 10,
          MaxReturnCountSpecified: true,
        },
        Availability: {
          StartDate: new Date(),
          NumberOfDays: 7,
          MergeMethod: 2,
          FlagCampaign: true,
        },
      },
      Children: {
        Filter: {
          Ids: null,
          Type: 4,
        },
      },
    };
    const product_id = searchParams.get("product_id");
    const langParams = searchParams.get("lang");
    detailRequest.request.Language = `${
      langParams === "en" ? "en-US" : "ja-JP"
    }`;
    quoteRequest.request.Language = `${
      langParams === "en" ? "en-US" : "ja-JP"
    }`;

    setProductId(product_id);

    detailRequest.request.ShortName = distributorQuick;

    axios
      .post(endpoints.search, detailRequest, { headers: headers })
      .then((response) => {
        setService(response.data.Entities[0]);
        setDetailShow(true);
      });
  }, [searchParams, location]);

  useEffect(() => {
    service && setCategorySelected(String(service.IndustryCategoryGroups[0]));
    if (service && service.IndustryCategoryGroups[0] === 3) {
      getQuote();
    }
  }, [service]);

  useEffect(() => {
    setBookingQuotes(bookingQuotes.sort((a, b) => a.Name - b.Name));
  }, [bookingQuotes]);

  const getQuote = (values) => {
    setProductItemShow("none");

    quoteRequest.request.Configurations[0].Pax.Adults =
      parseInt(values && values.pax) || 1;
    quoteRequest.request.Configurations[0].Pax.Children =
      parseInt(values && values.children) || 0;
    if (service.IndustryCategoryGroups[0] === 1) {
      quoteRequest.request.Configurations[0].Pax.Seniors =
        parseInt(values && values.seniors) || 0;
    } else {
      quoteRequest.request.Configurations[0].Pax.Seniors = 0;
    }
    quoteRequest.request.CommencementDate =
      (values && values.date) || new Date();
    quoteRequest.request.Duration = parseInt(values && values.duration) || null;

    if (service && service.Children.length > 0) {
      setBookingQuotes([]);
      quoteRequest.request.Shortname = distributorQuick;

      if (productId) {
        let indexId = 0;
        let selectedId = {};
        service.Children.forEach((children, i) => {
          if (children.Code === productId) {
            indexId = i;
            selectedId = children;

            dispatchQuoteBooking(selectedId, indexId);
          }
        });
      } else {
        service.Children.map((children, i) => {
          dispatchQuoteBooking(children, i);
        });
      }
    }
  };

  const dispatchQuoteBooking = (children, i) => {
    quoteRequest.request.IndustryCategoryGroup =
      children.IndustryCategoryGroups[0];
    quoteRequest.request.IndustryCategory = children.IndustryCategory;
    quoteRequest.request.Configurations[0].ProductId = children.Id;
    setSkeletonItemShow("block");

    axios
      .post(endpoints.bookingQuote, quoteRequest, { headers: headers })
      .then((response) => {
        const mergeData = { ...service.Children[i], ...response.data };
        mergeData.id = response.data.Configurations[0].ProductId;
        mergeData.quantity = 1;
        mergeData.price = response.data.Configurations[0].Quotes
          ? response.data.Configurations[0].Quotes[0].TotalPrice
          : null;
        setBookingQuotes((data) => [...data, mergeData]);

        setProductItemShow("block");
        setSkeletonItemShow("none");
      })
      .catch((error) => {
        console.log(error);
        setErrorItems(true);
        setProductItemShow("block");
        setSkeletonItemShow("none");
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let values = null;
    if (service.IndustryCategoryGroups[0] !== 3) {
      values = {
        date: e.target[0] ? e.target[0].value : "",
        duration:
          service.IndustryCategoryGroups[0] === 0 ? e.target[1].value : null,
        pax:
          service.IndustryCategoryGroups[0] === 0
            ? e.target[2].value
            : e.target[1].value,
        children:
          service.IndustryCategoryGroups[0] === 0
            ? e.target[3].value
            : e.target[2].value,
        seniors:
          service.IndustryCategoryGroups[0] === 0
            ? e.target[4].value
            : e.target[3].value,
      };
      setQuotesInfo(values);
    }

    getQuote(values);
  };

  const changeQuantity = (value, id) => {
    bookingQuotes.map((item) => {
      if (item.id === id) {
        item.quantity = value;
        const price = value * item.Configurations[0].Quotes[0].TotalPrice;
        if (!isEmpty(totalPrice)) {
          totalPrice.map((item) => {
            if (item.id === id) {
              setTotalPrice(
                produce((draft) => {
                  const dataPrice = draft.find((item) => item.id === id);
                  dataPrice.totalPrice = price;
                })
              );
            } else {
              setTotalPrice((prev) => [...prev, { id: id, totalPrice: price }]);
            }
          });
        } else {
          setTotalPrice((prev) => [...prev, { id: id, totalPrice: price }]);
        }
      }
    });
  };

  const settings = {
    dots: true,
    adaptiveHeight: true,
  };

  const checkWishlist = (item) => {
    const check = wishlists && wishlists.find((wish) => wish.Id === item.Id);

    return check;
  };

  const getServiceType = () => {
    let serviceType = t("accommodation");
    if (service && service.IndustryCategoryGroups) {
      switch (service.IndustryCategoryGroups[0]) {
        case 0:
          serviceType = t("accommodation");
          break;
        case 1:
          serviceType = t("activity");
          break;
        case 2:
          serviceType = t("restaurant");
          break;
        case 3:
          serviceType = t("produce");
          break;
        default:
          return t("accommodation");
      }
    }

    return serviceType;
  };

  return (
    <div className="productDetail">
      <div className="container">
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            navigate(-1);
          }}
          className="back"
        >
          <FontAwesomeIcon icon={faArrowLeft} className="me-2" />
          {t("go_back")}
        </a>
        <Row className="product">
          <div
            className="skeletonWrapper"
            style={{ display: !detailShow ? "block" : "none" }}
          >
            <SkeletonDetail />
          </div>
          {service && (
            <>
              <Col
                xs={12}
                lg={categorySelected && categorySelected === "3" ? 12 : 7}
                className="productWrapper"
                style={{ display: detailShow ? "block" : "none" }}
              >
                <div className="serviceType">{getServiceType()}</div>
                <h2 className="title mb-5">{service.Name}</h2>
                <div className="carousel">
                  {service.Images !== null ? (
                    <Slider {...settings}>
                      {service.Images.map((service, i) => {
                        return (
                          <div key={i}>
                            <img className="image" src={service.Url} />
                          </div>
                        );
                      })}
                    </Slider>
                  ) : (
                    <img src={DefaultImg} />
                  )}
                </div>
                <div
                  className="description mb-3"
                  dangerouslySetInnerHTML={{ __html: service.LongDescription }}
                ></div>
                {categorySelected && categorySelected !== "3" && (
                  <div className="text-center my-4">
                    <Button
                      className="w-100 mb-2"
                      variant="primary"
                      onClick={() =>
                        checkWishlist(service)
                          ? removeWishlist(service)
                          : addWishlist(service)
                      }
                    >
                      {checkWishlist(service)
                        ? t("remove_wishlist")
                        : t("add_to_reservation")}
                    </Button>
                  </div>
                )}

                <div
                  className="availableProducts mb-4"
                  style={{ display: productItemShow }}
                >
                  <div className="sectionTitle">
                    <span>
                      {service?.IndustryCategoryGroups &&
                      service.IndustryCategoryGroups[0] === 1
                        ? t("available_products_activity")
                        : service.IndustryCategoryGroups[0] === 3
                        ? t("available_products_goods")
                        : t("available_products")}
                    </span>
                  </div>
                  <ProductItems
                    bookingQuotes={bookingQuotes}
                    changeQuantity={changeQuantity}
                    language={language}
                    service={service}
                    quotesInfo={quotesInfo}
                    error={errorItems}
                    totalPrice={totalPrice}
                  />
                </div>
                <SkeletonItems skeletonItemShow={skeletonItemShow} />
                <div className="info mb-4">
                  <div className="sectionTitle">
                    <span>{t("basic_info")}</span>
                  </div>
                  <BasicInfo service={service} />
                </div>
                {service.Geocodes !== null && (
                  <div className="map">
                    <div className="sectionTitle">
                      <span>{t("map")}</span>
                    </div>
                    <div className="mapContainer">
                      <Map positions={service} />
                    </div>
                  </div>
                )}
              </Col>
              {categorySelected && categorySelected !== "3" && (
                <div className="col-12 col-lg-5 rightSection">
                  <div className="wishlistWrapper productItems">
                    <div className="wishlistTitle">{t("wishlists")}</div>
                    <div className="wishlistItems">
                      {wishlists && wishlists.length > 0 ? (
                        wishlists.map((wishlist, i) => {
                          return (
                            <div className="itemWishlist item" key={i}>
                              <div className="imageContainer">
                                <div
                                  className="image"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    goToDetail(wishlist.Id);
                                  }}
                                >
                                  <img
                                    src={
                                      wishlist.Images &&
                                      wishlist.Images.length > 0
                                        ? wishlist.Images[0].Url
                                        : DefaultImg
                                    }
                                    alt={wishlist.Name}
                                  />
                                </div>
                              </div>
                              <div className="info">
                                <a
                                  href="#"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    goToDetail(wishlist.Id);
                                  }}
                                >
                                  <h6 className="title">{wishlist.Name}</h6>
                                </a>
                                <div className="price">
                                  {wishlist &&
                                    wishlist.Availability?.Calendar
                                      ?.LowestRate &&
                                    (language === "jp"
                                      ? `¥${formatMoney(
                                          wishlist.Availability.Calendar
                                            .LowestRate
                                        )} から`
                                      : `From ¥${formatMoney(
                                          wishlist.Availability.Calendar
                                            .LowestRate
                                        )}`)}
                                </div>
                                <div
                                  className="desc"
                                  dangerouslySetInnerHTML={{
                                    __html: wishlist.LongDescription,
                                  }}
                                ></div>
                              </div>
                              <div
                                className="removeWishlist"
                                onClick={() => removeWishlist(wishlist)}
                              >
                                <FontAwesomeIcon icon={faTrashAlt} />
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <div className="wishlistEmpty">
                          {t("wishlist_empty")}
                        </div>
                      )}
                    </div>
                    <div className="wishlistButton">
                      {!isEmpty(wishlists) && (
                        <Button
                          className="w-100 mb-2"
                          variant="primary"
                          onClick={() => wishlistInjection()}
                        >
                          {t("check_availability")}{" "}
                        </Button>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </Row>
      </div>
    </div>
  );
};

export default ProductDetail;
